function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ORDER_STATUS_PENDING = 'pending';
var ORDER_STATUS_SETTLING = 'settling';
var ORDER_STATUS_FULFILLED = 'fulfilled';
var ORDER_STATUS_UNFULFILLABLE = 'unfulfillable';
var Order = /*#__PURE__*/function () {
  function Order() {
    var _data$id, _data$price, _data$quantity, _data$payment_output_, _data$payment_amount, _ref, _ref2, _data$block_id_receiv, _ref3, _ref4, _data$transaction_id_, _ref5, _data$longest_chain_r, _data$block_id_fulfil, _data$transaction_id_2, _data$longest_chain_f, _data$attempts;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Order);
    this.id = (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : 0;
    this.order_tx_sig = data.order_tx_sig || data.signature || '';
    this.signature = this.order_tx_sig;
    this.buyer = data.buyer || '';
    this.nft_id = data.nft_id || '';
    this.price = Number((_data$price = data.price) !== null && _data$price !== void 0 ? _data$price : 0);
    this.quantity = Number((_data$quantity = data.quantity) !== null && _data$quantity !== void 0 ? _data$quantity : 1);
    this.note = data.note || '';
    this.payment_tx_sig = data.payment_tx_sig || data.order_tx_sig || data.signature || '';
    this.payment_output_index = Number((_data$payment_output_ = data.payment_output_index) !== null && _data$payment_output_ !== void 0 ? _data$payment_output_ : 0);
    this.payment_amount = Number((_data$payment_amount = data.payment_amount) !== null && _data$payment_amount !== void 0 ? _data$payment_amount : 0);
    this.inbound_payment_uuid = data.inbound_payment_uuid || '';
    this.transfer_uuid = data.transfer_uuid || '';
    this.utxo_slip = data.utxo_slip || data.payment_utxo_slip || '';
    this.access_hash = data.access_hash || data.payment_access_hash || '';
    this.access_script = data.access_script || data.payment_access_script || '';
    this.p2sh_address = data.p2sh_address || data.payment_p2sh_address || '';
    this.block_id_received = Number((_ref = (_ref2 = (_data$block_id_receiv = data.block_id_received) !== null && _data$block_id_receiv !== void 0 ? _data$block_id_receiv : data.block_id_added) !== null && _ref2 !== void 0 ? _ref2 : data.block_id) !== null && _ref !== void 0 ? _ref : 0);
    this.block_hash_received = data.block_hash_received || data.block_hash_added || data.block_hash || '';
    this.transaction_id_received = Number((_ref3 = (_ref4 = (_data$transaction_id_ = data.transaction_id_received) !== null && _data$transaction_id_ !== void 0 ? _data$transaction_id_ : data.transaction_id_added) !== null && _ref4 !== void 0 ? _ref4 : data.transaction_id) !== null && _ref3 !== void 0 ? _ref3 : 0);
    this.longest_chain_received = (_ref5 = (_data$longest_chain_r = data.longest_chain_received) !== null && _data$longest_chain_r !== void 0 ? _data$longest_chain_r : data.longest_chain_added) !== null && _ref5 !== void 0 ? _ref5 : 1;
    this.settlement_tx_sig = data.settlement_tx_sig || '';
    // Web serialization of the signed settlement. The signature alone cannot be rebroadcast.
    this.settlement_tx = data.settlement_tx || '';
    this.block_id_fulfilled = Number((_data$block_id_fulfil = data.block_id_fulfilled) !== null && _data$block_id_fulfil !== void 0 ? _data$block_id_fulfil : 0);
    this.block_hash_fulfilled = data.block_hash_fulfilled || '';
    this.transaction_id_fulfilled = Number((_data$transaction_id_2 = data.transaction_id_fulfilled) !== null && _data$transaction_id_2 !== void 0 ? _data$transaction_id_2 : 0);
    this.longest_chain_fulfilled = (_data$longest_chain_f = data.longest_chain_fulfilled) !== null && _data$longest_chain_f !== void 0 ? _data$longest_chain_f : 0;
    this.attempts = Number((_data$attempts = data.attempts) !== null && _data$attempts !== void 0 ? _data$attempts : 0);
    this.status = data.status || ORDER_STATUS_PENDING;
    this.created_at = data.created_at || 0;
    this.updated_at = data.updated_at || data.created_at || 0;
  }
  return _createClass(Order, [{
    key: "isReceivedOnChain",
    value: function isReceivedOnChain() {
      return Number(this.longest_chain_received) === 1;
    }
  }, {
    key: "isFulfilledOnChain",
    value: function isFulfilledOnChain() {
      return Number(this.block_id_fulfilled) > 0 && Number(this.longest_chain_fulfilled) === 1;
    }
  }, {
    key: "isOnLongestChain",
    value: function isOnLongestChain() {
      return this.isReceivedOnChain();
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.status === ORDER_STATUS_PENDING;
    }
  }, {
    key: "isSettling",
    value: function isSettling() {
      return this.status === ORDER_STATUS_SETTLING;
    }
  }, {
    key: "isFulfilled",
    value: function isFulfilled() {
      return this.status === ORDER_STATUS_FULFILLED;
    }
  }, {
    key: "isUnfulfillable",
    value: function isUnfulfillable() {
      return this.status === ORDER_STATUS_UNFULFILLABLE;
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.isReceivedOnChain() && (this.isPending() || this.isSettling());
    }
  }, {
    key: "isProcessable",
    value: function isProcessable() {
      return this.isReceivedOnChain() && !this.isFulfilledOnChain() && !this.isUnfulfillable() && this.isPending() && !this.settlement_tx_sig;
    }
  }, {
    key: "isAwaitingSettlementConfirmation",
    value: function isAwaitingSettlementConfirmation() {
      return this.isSettling() && this.settlement_tx_sig && Number(this.block_id_fulfilled) === 0;
    }
  }, {
    key: "isOrphanedSettlement",
    value: function isOrphanedSettlement() {
      return this.isSettling() && Number(this.block_id_fulfilled) > 0 && Number(this.longest_chain_fulfilled) === 0;
    }
  }, {
    key: "toInsertParams",
    value: function toInsertParams() {
      var _this$price, _this$quantity, _this$payment_output_, _this$payment_amount, _this$block_id_receiv, _this$transaction_id_, _this$longest_chain_r, _this$block_id_fulfil, _this$transaction_id_2, _this$longest_chain_f, _this$attempts;
      var now = Date.now();
      return {
        $order_tx_sig: this.order_tx_sig,
        $buyer: this.buyer,
        $nft_id: this.nft_id,
        $price: Number((_this$price = this.price) !== null && _this$price !== void 0 ? _this$price : 0),
        $quantity: Number((_this$quantity = this.quantity) !== null && _this$quantity !== void 0 ? _this$quantity : 1),
        $note: this.note || '',
        $payment_tx_sig: this.payment_tx_sig,
        $payment_output_index: Number((_this$payment_output_ = this.payment_output_index) !== null && _this$payment_output_ !== void 0 ? _this$payment_output_ : 0),
        $payment_amount: Number((_this$payment_amount = this.payment_amount) !== null && _this$payment_amount !== void 0 ? _this$payment_amount : 0),
        $inbound_payment_uuid: this.inbound_payment_uuid || '',
        $transfer_uuid: this.transfer_uuid || '',
        $utxo_slip: this.utxo_slip || '',
        $access_hash: this.access_hash || '',
        $access_script: this.access_script || '',
        $p2sh_address: this.p2sh_address || '',
        $block_id_received: Number((_this$block_id_receiv = this.block_id_received) !== null && _this$block_id_receiv !== void 0 ? _this$block_id_receiv : 0),
        $block_hash_received: this.block_hash_received || '',
        $transaction_id_received: Number((_this$transaction_id_ = this.transaction_id_received) !== null && _this$transaction_id_ !== void 0 ? _this$transaction_id_ : 0),
        $longest_chain_received: (_this$longest_chain_r = this.longest_chain_received) !== null && _this$longest_chain_r !== void 0 ? _this$longest_chain_r : 1,
        $settlement_tx_sig: this.settlement_tx_sig || '',
        $block_id_fulfilled: Number((_this$block_id_fulfil = this.block_id_fulfilled) !== null && _this$block_id_fulfil !== void 0 ? _this$block_id_fulfil : 0),
        $block_hash_fulfilled: this.block_hash_fulfilled || '',
        $transaction_id_fulfilled: Number((_this$transaction_id_2 = this.transaction_id_fulfilled) !== null && _this$transaction_id_2 !== void 0 ? _this$transaction_id_2 : 0),
        $longest_chain_fulfilled: (_this$longest_chain_f = this.longest_chain_fulfilled) !== null && _this$longest_chain_f !== void 0 ? _this$longest_chain_f : 0,
        $attempts: Number((_this$attempts = this.attempts) !== null && _this$attempts !== void 0 ? _this$attempts : 0),
        $status: this.status || ORDER_STATUS_PENDING,
        $created_at: this.created_at || now,
        $updated_at: this.updated_at || now
      };
    }
  }]);
}();
module.exports = Order;
module.exports.ORDER_STATUS_PENDING = ORDER_STATUS_PENDING;
module.exports.ORDER_STATUS_SETTLING = ORDER_STATUS_SETTLING;
module.exports.ORDER_STATUS_FULFILLED = ORDER_STATUS_FULFILLED;
module.exports.ORDER_STATUS_UNFULFILLABLE = ORDER_STATUS_UNFULFILLABLE;